<template>
  <el-container>
    <el-container>
      <el-main >
        <app-main />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AppMain from './AppMain'
export default {
  name: 'Layout',
  components: {
    'app-main': AppMain
  },
  computed: {
  }
}
</script>

<style lang="stylus" scoped>
@import "../../assets/styl/variables.styl"

.el-container
  width 100%
  height 100%

.el-main
  padding 0
  height 100%
  overflow auto
.main
  height 100%
</style>
